import { ReactNode } from "react";

export const WebsiteAccordion = ({
  title,
  content,
  isOpen,
}: {
  title: ReactNode;
  content: ReactNode;
  isOpen: boolean;
}) => {
  return (
    <div className="flex flex-col gap-6">
      <div>{title}</div>
      {isOpen && (
        <div className="text-lg text-pry-dark-green-300/70">{content}</div>
      )}
    </div>
  );
};
